import ConsultaBase from "../shared/ConsultaBase";
import { fullServiceCooling1CompConsultaConfig } from "../config/fullServiceCooling1CompConsulta";

const CFSC1Comp = () => {
  return <ConsultaBase config={fullServiceCooling1CompConsultaConfig} />;
};

export default CFSC1Comp;